import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=286e42a8&scoped=true&"
import script from "./goodsList.vue?vue&type=script&lang=js&"
export * from "./goodsList.vue?vue&type=script&lang=js&"
import style0 from "./goodsList.vue?vue&type=style&index=0&id=286e42a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286e42a8",
  null
  
)

component.options.__file = "src/demo/packageMall/goodsList.vue"
export default component.exports